import type { EventDetail } from "@cdt/shared";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { DASHBOARD_STATS_QUERY_KEY } from "@/hooks/useDashboardStats";
import { ApiError } from "@/lib/api";
import { retryEvent } from "@/lib/eventsApi";

export function useDashboardRetryEvent() {
  const qc = useQueryClient();

  return useMutation<EventDetail, unknown, { id: string }>({
    mutationFn: ({ id }) => retryEvent(id),
    onSuccess: (data) => {
      if (data.status === "CREATED") {
        toast.success("Retry riuscito, evento creato in calendario");
      } else {
        toast.warning("Retry completato ma evento ancora in errore");
      }

      qc.setQueryData(["events", "detail", data.id], data);
      qc.invalidateQueries({ queryKey: ["events"] });
      qc.invalidateQueries({ queryKey: DASHBOARD_STATS_QUERY_KEY });
      qc.invalidateQueries({ queryKey: ["dashboard", "metrics"] });
    },
    onError: (error) => {
      if (error instanceof ApiError && error.status === 422) {
        const body = error.body as { error?: string } | null;
        toast.error(body?.error ?? "Dati insufficienti per il retry");
        return;
      }
      if (error instanceof ApiError && error.status === 409) {
        toast.warning("Stato evento non compatibile con il retry, aggiorno i dati");
        qc.invalidateQueries({ queryKey: ["events"] });
        return;
      }
      const message = error instanceof Error ? error.message : String(error);
      toast.error(`Retry fallito: ${message}`);
    },
  });
}
